import {
	Box,
	DialogTitle,
	IconButton,
	useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import sizeFontCustom from '../Discovery/fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { iconButtonTouchTargetSx } from '../../utils/a11y.utils';

function CustomDialogTitle(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const {
		children,
		onClose,
		centeredText,
		customDetails,
		isConsentRenewal,
		isGrievance,
		...other
	} = props;
	return (
		<DialogTitle
			sx={{
				...sizeFontCustom.dialogTitle,
				fontWeight: 900,
				p: '0',
				textAlign: centeredText ? 'center' : '',
				display: 'flex',
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				position: 'relative',
			}}
			{...other}
		>
			<Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
			{onClose ? (
				<IconButton
					size="small"
					aria-label={t('common.buttons.close')}
					onClick={onClose}
					sx={{
						flexShrink: 0,
						ml: '0.5rem',
						mt: isGrievance ? 0 : '-0.25rem',
						mr: isGrievance ? 0 : '-0.5rem',
						p: isGrievance ? 0 : '0.25rem',
						...iconButtonTouchTargetSx,
						color: isGrievance
							? '#000000'
							: isConsentRenewal
							? 'inherit'
							: customDetails?.primaryColor || theme.palette.primary.main,
						background: isGrievance
							? 'transparent'
							: isConsentRenewal
							? 'none'
							: customDetails?.primaryColor
							? `${customDetails.primaryColor}20`
							: theme.palette.primary.light,
					}}
				>
					<CloseIcon
						sx={{
							fontSize: isGrievance ? '24px' : '1.25rem',
							width: isGrievance ? '24px' : '1.25rem',
							height: isGrievance ? '24px' : '1.25rem',
						}}
					/>
				</IconButton>
			) : null}
		</DialogTitle>
	);
}
export default CustomDialogTitle;
